import { GroupBase, StylesConfig } from "react-select";

export const customReactSelectStyle: Partial<StylesConfig<any, false, GroupBase<any>>> = {
  // @ts-ignore
  input: base => ({
    ...base,
    padding: "5px",
  }),
  // @ts-ignore
  placeholder: base => ({
    ...base,
    padding: "5px",
  }),
  // @ts-ignore
  control: (base, state) => {
    let style = {
      ...base,
      borderColor: "#DCDCDD",
      borderRadius: "6px",
    };

    if (state.isFocused) {
      style = {
        ...style,
        boxShadow: "0 0 0 1px #005AE1",
        border: "1px solid #005AE1",
      };
    }

    return style;
  },
  // @ts-ignore
  indicatorSeparator: base => ({
    ...base,
    background: "#e2e8f0",
  }),
  // @ts-ignore
  singleValue: base => ({
    ...base,
    padding: "5px",
  }),
  // @ts-ignore
  menu: base => ({
    ...base,
    zIndex: 55,
  }),
  // @ts-ignore
  option: (base, state) => ({
    ...base,
    position: "relative",
  }),
};
